import React, { useState } from 'react';
import { connect } from 'react-redux';
import moment from 'moment'
import toast from "react-hot-toast";
import { Box } from '@mui/material'

import AddSuperUserAutocomplete from '../../../common/CustomInput/addSuperUserAutocomplete'
import { AddAmbassador } from "../../../redux/ambassador/actions";
import CustomActionButton from '../../../common/CustomActionButton';
import { apiCallV2 } from '../../../utils/api'
import { delay } from '../../../utils';

let timer = null
const AddAmbassadorModal = (props) => {
    const { setCount, setShow } = props;

    // autocomplete states
    const [open, setOpen] = useState(false);
    const [options, setOptions] = useState([]);
    const loading = open && options.length === 0;

    const [selected, setSelected] = useState('')

    const handleConfirm = async () => {

        const res = await props.AddAmbassador(selected);

        if (res.success) {
            toast.success('Added to Ambassadors')

            delay(() => {
                setShow(false);
            }, 2000);

            return true;
        }

        if (res.data.status === 500) {
            toast.error(res.message)
            return false;
        }
    }

    // fetch all users to select for super user
    const handleOptions = async (value) => {
        setOptions([])
        clearTimeout(timer)
        timer = setTimeout(async () => {

            const res = await apiCallV2(
                "GET",
                "get-users",
                "",
                localStorage.getItem("access-token"),
                {
                    page: null,
                    count: null,
                    filters: { search: value, admin_id: null }
                },
            );

            setOptions(res.data.users)
        }, 600)

    }
    return (
        <div id="add-ambasador-container">
            <Box display="flex" sx={{ justifyContent: 'center' }}>
                <AddSuperUserAutocomplete handleOptions={handleOptions} open={open} setOpen={setOpen} loading={loading} setOptions={setOpen} options={options} setSelected={setSelected} />
            </Box>
            {selected ? (
                <>
                    <h5>
                        {selected?.first_name} {selected?.last_name}  {selected?.dob && ("- DOB: " + moment(selected?.dob).format('MMM-DD-YYYY'))}
                    </h5>
                    <h5>
                        {selected?.name}
                    </h5>
                    <div className='add-amb-action'>
                        <CustomActionButton action={handleConfirm}>SUBMIT</CustomActionButton>
                    </div>

                </>
            ) :
                ''
            }
        </div>
    );
};

const mapStateToProps = (state) => ({
    Ambassador: state.Ambassador
})

export default connect(mapStateToProps, {
    AddAmbassador,
})(AddAmbassadorModal);